import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 26,
  label: "所属国申请量分析",
  chart: charts.worldMap,
  definition: {
    rowDims: [{ name: "country", label: "所属国", needTotal: true }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    condition: {
      items: [
        {
          name: "country",
          operator: "NOT_NULL",
        },
      ],
    },
  },
  chartOption: {
    chartType: ChartType.GEO,
    title: "所属国申请量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
  },
};
